import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { ConsultarFuncionalidadesRequest, Types } from './types';
import {
	consultarFuncionalidadeSuccess,
	consultarFuncionalidadeFailure,
} from './actions';

// UTILS

function* consultarFuncionalidadeRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarFuncionalidadesRequest } = request;

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as ConsultarFuncionalidadesRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`funcionalidades`,
		body,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarFuncionalidadeSuccess(response));
	} else {
		yield put(consultarFuncionalidadeFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_FUNCIONALIDADES_REQUEST,
		consultarFuncionalidadeRequest,
	),
]);
